/** Admin guide §1 — Users (`admin/UsersTab.tsx`, Settings → Users). */
import { helpSectionMeta } from '../help-sections.js';
import {
  Btn,
  Bullets,
  Callout,
  HelpSectionCard,
  Li,
  P,
  Screen,
  Shot,
  SubHead,
} from '../HelpPrimitives.js';

export function AdminUsers(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('admin-users')}>
      <Shot
        slug="admin-users"
        caption="The Users table: Name, Email, Role, Team and per-user Outlook status."
      />
      <P>
        The table lists every account — Name, Email, Role, Team, Outlook status, and an actions
        column. Click <Btn>Add</Btn>, or the pencil icon on a row, to open the user dialog.
      </P>

      <SubHead>The user dialog</SubHead>
      <Bullets>
        <Li>
          <Btn>Name</Btn> and <Btn>Email</Btn> are required.
        </Li>
        <Li>
          <Btn>Password</Btn> is required when adding a new user; when editing an existing one,
          leave it blank to keep the current password.
        </Li>
        <Li>
          <Btn>Role</Btn> and, optionally, <Btn>Team</Btn>.
        </Li>
        <Li>
          <Btn>Avatar (initials)</Btn> — up to three characters, shown in the sidebar.
        </Li>
        <Li>
          <Btn>Email Signature</Btn> — the same rich-text editor used elsewhere in the app.
        </Li>
        <Li>
          <Btn>Mailbox Settings</Btn> — a collapsible block for IMAP/SMTP Host, Port, User and
          Password. It is only saved once you fill in an IMAP host.
        </Li>
      </Bullets>

      <SubHead>Outlook, per user</SubHead>
      <P>
        Each row also shows that user&rsquo;s <Screen>Connect Outlook</Screen> status —{' '}
        <Btn>Connect Outlook</Btn> or <Btn>Connected</Btn> with a <Btn>Disconnect</Btn> action.
        Disconnecting asks you to confirm first.
      </P>

      <Callout title="Deleting a user is immediate">
        <P>
          The trash icon deletes the account right away — there is no confirmation step. It is
          hidden on your own row, so you can&rsquo;t remove yourself by mistake.
        </P>
      </Callout>
    </HelpSectionCard>
  );
}
